// 基础设置 form
export const formSchemas = [
  {
    field: 'remark',
    defaultValue: '',
    component: 'Input',
    label: '菜单标题',
    placeholder: '请输入菜单标题',
    rules: [
      {
        required: true,
        message: '菜单标题不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'url',
    defaultValue: '',
    component: 'Input',
    label: '路由地址',
    placeholder: '请输入路由地址',
    rules: [
      {
        required: true,
        message: '路由地址不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'iconUrl',
    defaultValue: '',
    component: 'Input',
    label: '图标',
    placeholder: '请输入图标',
    rules: [
      {
        required: true,
        message: '图标不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'name',
    defaultValue: '',
    component: 'Input',
    label: '菜单标识',
    placeholder: '请输入菜单标识',
    rules: [
      {
        required: true,
        message: '菜单标识不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'parentId',
    defaultValue: '0',
    component: 'Cascader',
    label: '上级菜单',
    placeholder: '请选择上级菜单'
  },
  {
    field: 'type',
    defaultValue: 1,
    component: 'Radio',
    label: '菜单类型',
    placeholder: '请选择菜单类型',
    radioArr: [
      {
        label: '菜单',
        value: 1
      },
      {
        label: '按钮',
        value: 2
      }
    ]
  },

  {
    field: 'permissionId',
    defaultValue: '',
    component: 'SelectSearch',
    label: '后端权限',
    placeholder: '请选择后端权限'
  }
]
